import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

const AboutUs = () => {
  return (
    <div className=" tw-min-h-screen">
      <Navbar />

      {/* Header */}
      <div className="tw-mt-10 lg:tw-mt-20 tw-py-10 tw-px-4 md:tw-px-8 lg:tw-px-12">
        <div className="tw-max-w-6xl tw-mx-auto">
          <h2 className="tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-bold tw-text-gray-900 tw-mb-3">
            About Us
          </h2>
          <p className="tw-text-gray-600 tw-text-sm md:tw-text-base">
            Kalyan, Main Bazar Jodi Chart Satta Laksh365 Record Old History
            Historical Data Bracket Results Chart Online Live Book Digits Numbers
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="tw-px-4 md:tw-px-8 lg:tw-px-12 tw-mb-16">
        <div className="tw-max-w-6xl tw-mx-auto tw-space-y-6">
          
          <p className="tw-text-gray-700 tw-text-sm md:tw-text-base tw-leading-relaxed">
            Laksh365 is operated by S S international, a company incorporated under
            the laws of United Kingdom and regulated by the UK authority as the
            regulatory body responsible holding a (Sub-license with License number
            392/JAZ Sub-License GLH- OCCHKTV0707086017 granted on 21.08.2020).
          </p>

          <h1 className="tw-text-2xl md:tw-text-3xl tw-font-bold tw-text-gray-900">
            Laksh365 is into existence for past 30 years with more than 1.38 lac +
            members.
          </h1>

          <p className="tw-text-gray-700 tw-text-sm md:tw-text-base tw-leading-relaxed">
            We have proudly taken our culture from offline to online business and
            now stand as India's most trusted betting platform. Laksh365 is an
            international betting platform and has presence in more than 18
            countries. We truly value our customers and our endeavor is to provide
            best customer service and enable our customers to play online games
            with ease.
          </p>

          {/* Notice Box */}
          <div className="tw-flex tw-items-start tw-gap-3 tw-bg-gray-50 tw-border tw-border-gray-200 tw-rounded-2xl tw-p-4 md:tw-p-5">
            <div className="tw-text-gray-800">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                viewBox="0 0 24 24"
                height={28}
                width={28}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fill="none" d="M0 0h24v24H0V0z" />
                <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
              </svg>
            </div>

            <p className="tw-text-gray-700 tw-text-sm md:tw-text-base tw-leading-relaxed">
              Players are requested not to contact any untrusted sources for
              Laksh365 accounts.
            </p>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
